import { Box, HStack, Text } from '@chakra-ui/react'

const Certification = () => {
  return (
    <Box
      mt={12}
      w={{
        base: '100%',
        md: 600
      }}
      p={7}
      border={'2px solid #000'}
      data-aos="fade-up"
    >
      <HStack justifyContent="space-between">
        <Text textStyle="docInfo">Exam No: KDRI-DD-150610-0572</Text>
        <Text textStyle="docInfo">Test Period: 24.07.2015 - 07.08.2015</Text>
      </HStack>
      <Box mt={3}>
        <Text textStyle="docInfo">
          Testing Institution: Korea Dermatological Research Institue Co., Ltd.
        </Text>
      </Box>
      <Box mt={3}>
        <Text textStyle="docInfo">
          Test Subjects: 20 Women (Average age: 43)
        </Text>
      </Box>
    </Box>
  )
}

export default Certification
